export const constants = {
  SHOW_PRODUCT_DETAIL: 'SHOW_PRODUCT_DETAIL',
};
